<template>
    <div>
        <!-- Dialog Begin -->
        <el-dialog title="Import from CSV" 
        :visible.sync="dialogTableVisible" 
        :before-close="handleClose"
         v-loading.fullscreen="loading">
            <el-upload
                class="upload-demo"
                drag
                :stored="file"
                accept=".xls, .xlsx, .csv, .ods"
                action
                :http-request="loadCSV"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Suelta tu archivo aquí o
                    <em>haz clic para cargar</em>
                </div>
                <div
                    slot="tip"
                    class="el-upload__tip"
                >Solo archivos .xls, .xlsx, .csv menor de 500kb</div>
            </el-upload>
            
            <!-- Table BEGIN -->
            <template>
                <el-table
                ref="multipleTable"
                :data="parse_csv"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="Name category"
                    width="120">
                    <template slot-scope="scope">{{ scope.row.name }}</template>
                </el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                <el-button
                @click="save()"
                :disabled="loading"
                type="primary"
                icon="el-icon-fa-floppy-o"
            >Save</el-button>
                <el-button @click="toggleSelection()">Clear selection</el-button>
                </div>
            </template>
            <!-- Table END -->
        </el-dialog>
        <!-- Dialog END -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
/* eslint-disable */
export default {
    name: "app-club-import",
    data() {
        return {
            dialogTableVisible: true,
            file: null,
            parse_header: [],
            parse_csv: [],
            multipleSelection: [],
            sortOrders: {},
            sortKey: ""
        };
    },

    computed: {
        ...mapGetters({
            loading: "entities/category/loading"
        })
    },

    filters: {
        capitalize: function(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    },

    created() {        
        console.log("<--- created import");
        
        this.dialogTableVisible = true
    },

    beforeRouteUpdate(to, from, next) {
        console.log(to, from);
        
        next();
    },

    methods: {
        sortBy: function(key) {
            var vm = this;
            vm.sortKey = key;
            vm.sortOrders[key] = vm.sortOrders[key] * -1;
        },

        csvJSON(csv) {
            var vm = this;
            var lines = csv.split("\n");
            var result = [];
            var headers = lines[0].split(",");
            vm.parse_header = lines[0].split(",");
            lines[0].split(",").forEach(function(key) {
                vm.sortOrders[key] = 1;
            });
            lines.map(function(line, indexLine) {
                if (indexLine < 1) return; // Jump header line
                var currentline = line.split(",");
                var name = "";

                headers.map(function(header, indexHeader) {
                    if (header === `name`){
                        name = currentline[indexHeader].trim()
                    } else if(header === `"name"`) {
                        name = currentline[indexHeader].trim().substring(1)
                        name = name.trim().substring(0, name.length - 1)
                    }
                });

                var obj = {
                    name: name
                };

                result.push(obj);
            });
            return result; // JavaScript object
        },

        loadCSV(e) {
            var vm = this;
            var reader = new FileReader();
            reader.readAsText(e.file);
            // Handle errors load
            reader.onload = function(event) {
                var csv = event.target.result;
                vm.parse_csv = vm.csvJSON(csv);
            };
            reader.onerror = function(evt) {
                if (evt.target.error.name == "NotReadableError") {
                    alert("Canno't read file !");
                }
            };
        },

        toggleSelection(rows) {
          if (rows) {
            rows.forEach(row => {
              this.$refs.multipleTable.toggleRowSelection(row);
            });
          } else {
            this.$refs.multipleTable.clearSelection();
          }
        },

        handleSelectionChange(val) {
          this.multipleSelection = val;
        },

        save() {
          this.multipleSelection.forEach((it, index, array) => {

               this.$store.dispatch("entities/category/save", it).then(() => {
                if (index == array.length - 1 ) {
                  this.file = null
                  this.parse_csv = []
                  this.multipleSelection = []
                  this.dialogTableVisible = false       
                  this.$router.go(-1) 
                }
              });
          })
        },

       handleClose(done) {

        this.$confirm('Are you sure to close this dialog?')
          .then(_ => {
            done();
           this.$router.go(-1) 
          })
          .catch(_ => {});
      }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/category/category-import-csv.vue?746ab7d6